import React from 'react';
import ReactDOM from 'react-dom';

export const useOnClickOutside = (
  onClose,
  active = true
) => {
  const ref = React.useRef(null);

  const clickOutside = React.useCallback((e) => {
    if (!ref || !ref.current) {
      return;
    }

    // If we clicked inside, then do nothing.
    // eslint-disable-next-line react/no-find-dom-node
    const node = ReactDOM.findDOMNode(ref.current);
    if (node && node.contains(e.target)) {
      return;
    }

    // Invoke callback
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose]);

  // Attach listeners
  React.useEffect(() => {
    if(active) document.addEventListener('mousedown', clickOutside);
    return () => document.removeEventListener('mousedown', clickOutside);
  }, [clickOutside, active]);

  return [ref];
};
